<template>
  <header class="shadowed">
    <div class="col">
      <div class="row">
        <h2 @click="goHome">
          Numismafantastic
        </h2>
        <div
          v-if="!pending && !isAuthenticated"
          class="header-element"
        >
          <i
            class="icon fas fa-sign-in-alt"
            title="Se connecter"
            @click="goAuth"
          ></i>
        </div>
        <div
          v-if="!pending && isAuthenticated"
          class="header-element"
        >
          <div class="row">
            <i
              class="icon fas fa-toolbox"
              title="Adminsistration"
              @click="goToAdmin"
            ></i>
            <i
              class="icon fas fa-list"
              title="Ma collection"
              @click="goMyCollection"
            ></i>
            <i
              class="icon fas fa-sign-out-alt"
              title="Se déconnecter"
              @click="logout"
            ></i>
          </div>
        </div>
        <div
          v-if="pending"
          class="header-element"
        >
          <div class="spinner">
            <spinner></spinner>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import FirebaseAuth from '../tools/FirebaseAuth';
  import store from './../stores';
  import Spinner from './micro-components/spinner';

  export default {
    name: 'Header',
    components: { Spinner },
    computed: {
      isAuthenticated() {
        return store.state.auth.isAuthenticated;
      },
      pending() {
        return store.state.auth.isPending;
      },
    },
    methods: {
      goHome() {
        this.$router.push({ name: 'home' });
      },
      goAuth() {
        this.$router.push({ name: 'login' });
      },
      goMyCollection() {
        this.$router.push({ name: 'collection' });
      },
      goToAdmin() {
        this.$router.push({ name: 'admin-home' });
      },
      async logout() {
        await FirebaseAuth.logout();
        this.$router.push({ name: 'home' });
      }
    }
  };
</script>

<style scoped>
    header {
        z-index: 10;
        width: 100%;
        display: flex;
        flex-flow: row;
        height: 50px;
        border-bottom: 2px solid darkorange;
        background: #fdfdfd;
    }

    .shadowed {
        -moz-box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
        -webkit-box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
        -o-box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
        box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#1F2124, Direction=180, Strength=6);
    }

    .col {
        height: 100%;
        justify-content: center;
        width: 100%;
    }

    .row {
        width: 100%;
        justify-content: space-between;
        margin: 0;
    }

    h2 {
        padding: 0 1em;
        margin: 0;
        cursor: pointer;
    }

    .header-element {
        flex-flow: column;
        justify-content: center;
        display: flex;
    }

    .icon {
        transition: 1s ease all;
        margin-right: 1em;
        cursor: pointer;
    }

    .icon:hover {
        transition: 1s ease all;
        color: darkorange;
    }
    .spinner {
        margin-right: 1em;
    }
</style>
